import { Injectable } from '@angular/core';
import { Helpers } from './helpers';

@Injectable()
export class Globals {

    role: string = 'test';
    //public HOST: string = "http://applealtadapi.mipc:8888/api";
    public HOST: string = "https://prg-lealtad.clusterapis.acpdelsureste.net/api";
    public key_aes: string = "Acp120523.$";

    constructor() {

    }

    public getJSON(url, data, type, cache = false, before = true, asyn = false) {
        var rValue = "";
        if (typeof (cache) != "undefined") {
            cache = cache;
        } else {
            cache = false;
        }
        if (typeof (type) != "undefined") {
            type = type;
        } else {
            type = "GET";
        }

        if (typeof (url) == "undefined") {
            url = "/cpp/test";
        }

        this.HOST = this.HOST.replace(" ", "");
        let dataToken: any = JSON.parse(localStorage.getItem('currentUser'));
        let token: string;
        if (dataToken != null) {
            token = 'Bearer ' + dataToken.access_token;
        }
        $.ajax({
            type: type,
            beforeSend: function(request) {
                before === false ? '' : request.setRequestHeader("Authorization", token);
            },
            url: this.HOST + url,
            dataType: 'json',
            data: data,
            async: asyn,
            cache: cache,
            error: function(statusText, xhr) {
                // if (statusText.status == 401) {
                //     location.href = '/login';
                // }
            }
        }).done(function(json) {
            rValue = json;
            Helpers.setLoading(false);
        });
        return rValue;
    }

}


// WEBPACK FOOTER //
// ./src/app/globals.ts